import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import PublicLayout from "@/components/layout/PublicLayout";

import Home from "@/pages/public/Home";
import Seniorcar from "@/pages/public/Seniorcar";
import ProductSubPage from "@/pages/public/ProductSubPage";
import MobilitaHub from "@/pages/public/MobilitaHub";
import MobilitaLanding from "@/pages/public/MobilitaLanding";
import DispositivoMedico from "@/pages/public/DispositivoMedico";
import DispositivoMedicoSub from "@/pages/public/DispositivoMedicoSub";
import GuideHub from "@/pages/public/GuideHub";
import ArticleDetail from "@/pages/public/ArticleDetail";
import AuthorPage from "@/pages/public/AuthorPage";
import PrenotaProva from "@/pages/public/PrenotaProva";
import ProvaHub from "@/pages/public/ProvaHub";
import LocationPage from "@/pages/public/LocationPage";
import GuidaMobilita from "@/pages/public/GuidaMobilita";
import Rivenditori from "@/pages/public/Rivenditori";
import DealerDetail from "@/pages/public/DealerDetail";
import Faq from "@/pages/public/Faq";
import Contatti from "@/pages/public/Contatti";
import PrivacyPolicy from "@/pages/public/PrivacyPolicy";
import CookiePolicy from "@/pages/public/CookiePolicy";
import OffertaSpeciale from "@/pages/public/OffertaSpeciale";
import Assistenza from "@/pages/public/Assistenza";
import Search from "@/pages/public/Search";
import NotFound from "@/pages/public/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import { ForgotPassword, ResetPassword } from "@/pages/admin/PasswordPages";
import { ProtectedRoute } from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import LeadsAdmin from "@/pages/admin/LeadsAdmin";
import GuidesAdmin from "@/pages/admin/GuidesAdmin";
import DealersAdmin from "@/pages/admin/DealersAdmin";
import LocationsAdmin from "@/pages/admin/LocationsAdmin";
import SeoReport from "@/pages/admin/SeoReport";
import SeoAdmin from "@/pages/admin/SeoAdmin";

const P = (el) => <PublicLayout>{el}</PublicLayout>;
const A = (el) => <ProtectedRoute>{el}</ProtectedRoute>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={P(<Home />)} />
          <Route path="/seniorcar" element={P(<Seniorcar />)} />
          <Route path="/seniorcar/:sub" element={P(<ProductSubPage />)} />
          <Route path="/mobilita" element={P(<MobilitaHub />)} />
          <Route path="/mobilita/:slug" element={P(<MobilitaLanding />)} />
          <Route path="/dispositivo-medico" element={P(<DispositivoMedico />)} />
          <Route path="/dispositivo-medico/:slug" element={P(<DispositivoMedicoSub />)} />
          <Route path="/guide" element={P(<GuideHub />)} />
          <Route path="/offerta" element={P(<OffertaSpeciale />)} />
          <Route path="/assistenza" element={P(<Assistenza />)} />
          <Route path="/guida-mobilita" element={P(<GuidaMobilita />)} />
          <Route path="/guide/:slug" element={P(<ArticleDetail />)} />
          <Route path="/autori/:slug" element={P(<AuthorPage />)} />
          <Route path="/prenota-prova" element={P(<PrenotaProva />)} />
          <Route path="/prova-seniorcar" element={P(<ProvaHub />)} />
          <Route path="/prova-seniorcar/:city" element={P(<LocationPage />)} />
          <Route path="/rivenditori" element={P(<Rivenditori />)} />
          <Route path="/rivenditori/:city/:slug" element={P(<DealerDetail />)} />
          <Route path="/faq" element={P(<Faq />)} />
          <Route path="/contatti" element={P(<Contatti />)} />
          <Route path="/privacy" element={P(<PrivacyPolicy />)} />
          <Route path="/cookie" element={P(<CookiePolicy />)} />
          <Route path="/cerca" element={P(<Search />)} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/admin" element={A(<Dashboard />)} />
          <Route path="/admin/leads" element={A(<LeadsAdmin />)} />
          <Route path="/admin/guides" element={A(<GuidesAdmin />)} />
          <Route path="/admin/dealers" element={A(<DealersAdmin />)} />
          <Route path="/admin/locations" element={A(<LocationsAdmin />)} />
          <Route path="/admin/report" element={A(<SeoReport />)} />
          <Route path="/admin/seo" element={A(<SeoAdmin />)} />

          <Route path="*" element={P(<NotFound />)} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
